export default "__VITE_ASSET__BWYnCE2C__"